import { Button, Loader } from "@mantine/core";
import type React from "react";

export interface ConnectStatusExtended {
  has_connect_account?: boolean;
  onboarding_complete?: boolean;
  Code?: number;
  Message?: string;
  url?: string;
  [key: string]: unknown;
}

interface BankAccountTabProps {
  connectStatus: ConnectStatusExtended | null;
  connectLoading: boolean;
  onConnectBankAccount: () => void;
}

const BankAccountTab: React.FC<BankAccountTabProps> = ({
  connectStatus,
  connectLoading,
  onConnectBankAccount,
}) => (
  <div>
    <h2 className="text-2xl text-foreground mb-5">Bank Account</h2>
    {connectLoading ? (
      <div className="flex justify-center py-10">
        <Loader color="blue" />
      </div>
    ) : connectStatus?.onboarding_complete ? (
      <div className="bg-success/10 border border-success/30 rounded-[10px] p-4 sm:p-[30px] text-center">
        <div className="text-5xl mb-4">{"\u2705"}</div>
        <h3 className="text-success mb-2.5">Bank Account Connected</h3>
        <p className="text-success">
          Your bank account is connected. Session earnings will be deposited automatically.
        </p>
      </div>
    ) : (
      <div className="bg-warning/10 border border-warning/25 rounded-[10px] p-4 sm:p-[30px] text-center">
        <div className="text-5xl mb-4">{"\u{1F3E6}"}</div>
        <h3 className="text-warning mb-2.5">
          {connectStatus?.has_connect_account
            ? "Complete Your Setup"
            : "Connect Your Bank Account"}
        </h3>
        <p className="text-warning mb-5">
          {connectStatus?.has_connect_account
            ? "Your account setup is incomplete. Please finish onboarding to start receiving payouts."
            : "Connect your bank account through Stripe to receive session earnings directly."}
        </p>
        <Button onClick={onConnectBankAccount} disabled={connectLoading} size="md">
          {connectLoading
            ? "Please wait..."
            : connectStatus?.has_connect_account
              ? "Continue Setup"
              : "Connect Bank Account"}
        </Button>
      </div>
    )}
  </div>
);

export default BankAccountTab;
